<form class="field-dialog__content__scroll p-24" [formGroup]="maintenanceForm" fusePerfectScrollbar>
  <fc-outlined-input
    *ngIf="maintenanceNumberGeneratorType === 'none'"
    [control]="maintenanceForm.get('number')"
    [label]="'MAINTENANCES.CREATE_DIALOG.NUMBER_INPUT.LABEL' | translate"
    [required]="true"
  >
    <ng-container *ngIf="maintenanceForm.get('number').hasError('required')">
      {{ 'MAINTENANCES.CREATE_DIALOG.ERRORS.REQUIRED' | translate }}
    </ng-container>
    <ng-container *ngIf="maintenanceForm.get('number').hasError('pattern')">
      {{ 'MAINTENANCES.CREATE_DIALOG.NUMBER_INPUT.ERRORS.PATTERN' | translate }}
    </ng-container>
    <ng-container *ngIf="maintenanceForm.get('number').hasError('maxlength')">
      {{ 'MAINTENANCES.CREATE_DIALOG.NUMBER_INPUT.ERRORS.MAX_LENGTH' | translate }}
    </ng-container>
    <ng-container *ngIf="maintenanceForm.get('number').hasError('maintenanceNumberAlreadyExists')">
      {{ 'MAINTENANCES.CREATE_DIALOG.NUMBER_INPUT.ERRORS.NUMBER_DUPLICATED' | translate }}
    </ng-container>
  </fc-outlined-input>

  <fc-segment-input
    [control]="maintenanceForm.get('segment')"
    [requiredMark]="true"
    [preloadOptions]="true"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
  >
  </fc-segment-input>

  <fc-maintenance-type-input
    [control]="maintenanceForm.get('maintenanceType')"
    [preloadOptions]="true"
    [requiredMark]="true"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
    [selectedSegment]="selectedSegment"
  ></fc-maintenance-type-input>

  <fc-location-input
    [control]="maintenanceForm.get('location')"
    [requiredMark]="true"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
  ></fc-location-input>

  <fc-address-input
    [control]="maintenanceForm.get('address')"
    [requiredMark]="true"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
  ></fc-address-input>

  <schedule-suggestions [form]="maintenanceForm"></schedule-suggestions>

  <fc-company-input
    #companyInput
    [control]="maintenanceForm.get('company')"
    [searchOnFocus]="true"
    [requiredMark]="false"
    [compareWithCoords]="maintenanceForm.get('address').value?.coords"
  ></fc-company-input>

  <fc-deadline-contract-outlined-select
    [label]="'MAINTENANCES.TABS.GENERAL.INPUTS.DEADLINE_CONTRACT.LABEL' | translate"
    [control]="maintenanceForm.get('deadlineContract')"
    [required]="false"
  ></fc-deadline-contract-outlined-select>

  <fc-problem-input
    [segmentId]="maintenanceForm.get('segment').value?.id"
    [maintenanceTypeId]="maintenanceForm.get('maintenanceType').value?.id"
    [options]="problems"
    [control]="maintenanceForm.get('problem')"
    [requiredMark]="isProblemRequired && problems.length"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
  ></fc-problem-input>

  <fc-text-area-input
    [label]="'MAINTENANCES.HEADER.MESSAGE' | translate"
    [control]="maintenanceForm.get('message')"
    [requiredMark]="true"
    [maxLength]="2000"
    [translateErrorPrefix]="'MAINTENANCES.CREATE_DIALOG.ERRORS'"
  >
  </fc-text-area-input>

  <div
    class="attachments"
    #attachmentsDiv
    dropzone="copy"
    (click)="fileInput.click()"
    (dragover)="$event.preventDefault(); attachmentsDiv.classList.add('drag-over')"
    (dragenter)="$event.preventDefault(); attachmentsDiv.classList.add('drag-over')"
    (dragleave)="$event.preventDefault(); attachmentsDiv.classList.remove('drag-over')"
    (drop)="handleDropFile($event)"
  >
    <input type="file" multiple hidden #fileInput (change)="handleFileSelect($event)" />
    <div class="attachments__description" *ngIf="!maintenanceForm.get('attachments').value.length">
      <span class="attachments__title">{{ 'MAINTENANCES.CREATE_DIALOG.ADD_FILES_TITLE' | translate }}</span>
      <span class="attachments__subtitle">
        {{ 'MAINTENANCES.CREATE_DIALOG.ADD_FILES_DESCRIPTION' | translate }}
      </span>
    </div>

    <div class="attachments__items" *ngIf="maintenanceForm.get('attachments').value.length">
      <div
        class="attachments__thumbnail"
        *ngFor="let attachment of maintenanceForm.get('attachments').value; index as index"
      >
        <img
          [src]="attachment | getIcon"
          [ngClass]="{ 'fit-contain': !attachment.thumb, 'attachment-icon': true }"
          [matTooltip]="attachment.filename"
        />
        <mat-icon class="attachments__remove" (click)="removeAttachment($event, index)">close</mat-icon>
      </div>
    </div>

    <div class="attachments__actions" *ngIf="maintenanceForm.get('attachments').value.length">
      <button mat-stroked-button [disabled]="isLoading || maintenanceForm.get('attachments').value.length >= 10">
        <span>{{ 'MAINTENANCES.SELECT_ATTACHMENTS' | translate }}</span>
      </button>
    </div>
  </div>
</form>
